// ...existing code...
import { authFetch } from "~/services/fetch";

export async function getOccurrencesAssociatedOrgansByType({
  startDate,
  finishDate,
  actionTakenId,
  auxiliaryOrgansId,

}: {
  readonly startDate: string
  readonly finishDate: string
  readonly actionTakenId?: number | null
  readonly auxiliaryOrgansId?: number | null
}) {
  try {
    const { data } = await authFetch({
      url: '/statistics/occurrences-associated-organization-by-organization',
      method: 'POST',
      data: {
        start_date: startDate,
        finish_date: finishDate,
        action_taken_id: actionTakenId ?? null,
        organization_id: auxiliaryOrgansId ?? null
      }
    })
    return data;
  } catch (error) {
    throw error
  }
}

export async function getOccurrencesAssociatedOrgansByCircunstance({
  startDate,
  finishDate,
  actionTakenId,
  auxiliaryOrgansId,
}: {
  readonly startDate: string
  readonly finishDate: string
  readonly actionTakenId?: number | null
  readonly auxiliaryOrgansId?: number | null
}) {
  try {
    const { data } = await authFetch({
      url: '/statistics/occurrences-associated-organization-by-action-taken',
      method: 'POST',
      data: {
        start_date: startDate,
        finish_date: finishDate,
        action_taken_id: actionTakenId ?? null,
        organization_id: auxiliaryOrgansId ?? null
      }
    })
    return data;
  } catch (error) {
    throw error
  }
}

export async function getOccurrencesAssociatedOrgansByOccurrenceType({
  startDate,
  finishDate,
  actionTakenId,
  auxiliaryOrgansId,
}: {
  readonly startDate: string
  readonly finishDate: string
  readonly actionTakenId?: number | null
  readonly auxiliaryOrgansId?: number | null
}) {
  try {
    const { data } = await authFetch({
      url: '/statistics/occurrences-associated-organization-by-occurrence-type',
      method: 'POST',
      data: {
        start_date: startDate,
        finish_date: finishDate,
        action_taken_id: actionTakenId ?? null,
        auxiliary_organization_id: auxiliaryOrgansId ?? null
      }
    })
    return data;
  } catch (error) {
    throw error
  }
}